import { createContext as o } from "react";

const r = {
    model: void 0,
    variant: "solid",
    cellSpacing: "s",
    colorVariant: "primary",
    rowSeparator: !0,
    scrollToTop: () => {}
}, a = o(r);

export { a as default, r as defaultContext };
//# sourceMappingURL=index.js.map
